/**
 * The four CMT regions and how they look, in one place. GroupsMap paints the
 * world map with these colours and the calling campaigns use them for region
 * cards and chips, so a region reads the same everywhere.
 *
 * Keys match the backend (`app/campaigns/regions.py`, `geo_assignments.region`).
 */

export type RegionKey = "AMER" | "EMEA" | "APAC" | "LATAM" | "Unassigned";

export interface RegionMeta {
  key: RegionKey;
  label: string;
  long: string;
  color: string;
}

export const REGION_COLORS: Record<Exclude<RegionKey, "Unassigned">, string> = {
  AMER: "#003d45",
  EMEA: "#007a8a",
  APAC: "#ae232d",
  LATAM: "#D69E2E",
};

export const REGIONS: RegionMeta[] = [
  { key: "AMER", label: "AMER", long: "Americas (US & Canada)", color: REGION_COLORS.AMER },
  { key: "EMEA", label: "EMEA", long: "Europe, Middle East & Africa", color: REGION_COLORS.EMEA },
  { key: "APAC", label: "APAC", long: "Asia-Pacific", color: REGION_COLORS.APAC },
  { key: "LATAM", label: "LATAM", long: "Latin America & Caribbean", color: REGION_COLORS.LATAM },
  { key: "Unassigned", label: "Unassigned", long: "No usable country on file", color: "#94a3b8" },
];

export const REGION_BY_KEY = Object.fromEntries(REGIONS.map((r) => [r.key, r])) as Record<RegionKey, RegionMeta>;

export function regionMeta(key: string | null | undefined): RegionMeta {
  return REGION_BY_KEY[(key as RegionKey) ?? "Unassigned"] ?? REGION_BY_KEY.Unassigned;
}
